import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import app from 'new-ui/app';
import { EDIT_QUESTION_POPUP_ACTION_SOURCE } from 'utils/constants/actionSource';
import { useObjectRef } from 'utils/hooks/useObjectRef';
import { Intake, EXPAND_ALL } from 'new-ui/Components/Intake/Intake';
import './EditQuestion.css';

export const EditQuestion = ({ question, onClose }) => {
  const { data: user } = useSelector((state) => state.profile);
  const onCloseRef = useObjectRef(onClose);

  useEffect(() => () => {
    if (onCloseRef.current) {
      onCloseRef.current();
    }
  }, [onCloseRef]);

  return (
    <div className="edit-question-popup">
      <Intake
        id="editQuestionPopup"
        className="single-question-intake"
        user={user}
        flatMode
        expand={EXPAND_ALL}
        targetQuestions={[question]}
        onUpdate={() => {
          app.handleUserUpdate({ actionSource: EDIT_QUESTION_POPUP_ACTION_SOURCE });
        }}
        gotoResults={() => {
          app.closePopups();
        }}
      />
    </div>
  );
};

EditQuestion.propTypes = {
  question: PropTypes.string.isRequired,
  onClose: PropTypes.func,
};
